export default __webpack_public_path__ + "static/media/id-billing-logotype-l.1a9bd0db.svg";